import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap';

class CustomDropdown extends Component {
  constructor(props) {
    super(props);

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  /*:: toggleDropdown: () => void */
  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    const profilePic = this.props.profilePic ? this.props.profilePic : "https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68";

    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggleDropdown}
        className="notification-list"
      >
        <DropdownToggle
          data-toggle="dropdown"
          tag="button"
          className="btn btn-link nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"
          onClick={this.toggleDropdown}
          aria-expanded={this.state.dropdownOpen}
        >
          {/* componente passado via parametro */}
          {this.props.dropToggle}
        </DropdownToggle>
        <DropdownMenu right className="profile-dropdown">
          <div onClick={this.toggleDropdown}>
            {/* componente passado via parametro */}
            {this.props.dropMenu}
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default CustomDropdown;
